export default __webpack_public_path__ + "assets/images/e87c385288e4fbc35e67bad85d0cb2f0.png";